import { TpCanonicalTypeInfo, TpDataContext } from '../../../data/interfaces';
import { TpAutoFormDef, promptAutoForm } from '../../../components/auto-form-modal/AutoForm';
import { getSelectedItemCount } from './misc';
import { performUserSelectionAction } from '../../../data/analyticsDataSlice';
import { TpEnSelectionFilterTypes } from '../../../data/selection/interfaces';

interface TpClipBoardData {
  canonicalType: string;
  selectedItemsMap: { [itemId: string]: boolean };
  selectedItems: string[];
}

let currentClipBoardData: TpClipBoardData | null = null;

export function copySelection(canonicalTypeInfo: TpCanonicalTypeInfo) {
  const selectedItems = [];
  for (const itemId in canonicalTypeInfo.selectedItemsMap)
    if (canonicalTypeInfo.selectedItemsMap[itemId]) selectedItems.push(itemId);
  currentClipBoardData = {
    canonicalType: canonicalTypeInfo.id,
    selectedItemsMap: { ...canonicalTypeInfo.selectedItemsMap },
    selectedItems,
  };
}

export function clipboardHasCompatibleData(canonicalTypeInfo: TpCanonicalTypeInfo) {
  if (!currentClipBoardData) return false;
  return currentClipBoardData.canonicalType == canonicalTypeInfo.id;
}

export function pasteSelection(
  targetDataContext: TpDataContext,
  targetCanonicalTypeInfo: TpCanonicalTypeInfo,
  dispatch: any,
) {
  if (!clipboardHasCompatibleData(targetCanonicalTypeInfo)) return;
  const existingSelectionCount = getSelectedItemCount(targetCanonicalTypeInfo);
  const newSelectedCount = currentClipBoardData?.selectedItems.length;

  const filterAction = { filterType: 'action', content: ['Pasted from clipboard'] };

  if (existingSelectionCount == 0) {
    dispatch(
      performUserSelectionAction({
        dataContextId: targetDataContext.id,
        canonicalTypeId: targetCanonicalTypeInfo.id,
        userSelectionAction: {
          type: TpEnSelectionFilterTypes.MANUAL,
          description: 'Pasted from clipboard',
          method: 'replace',
          selectedItemIds: currentClipBoardData!.selectedItems,
        },
      }),
    );
  } else {
    const form: TpAutoFormDef = {
      title: 'Paste selection',
      description: `${newSelectedCount} items are present in the clipboard. ${existingSelectionCount} items are currently selected.`,
      fields: [],
      actionButtons: [
        { id: 'replace', content: 'Replace' },
        { id: 'addFilter', content: 'Add as filter step' },
        // { id: 'intersect', content: 'Intersect' },
        // { id: 'exclude', content: 'Exclude' },
      ],
    };
    promptAutoForm(form).then((formData: any) => {
      dispatch(
        performUserSelectionAction({
          dataContextId: targetDataContext.id,
          canonicalTypeId: targetCanonicalTypeInfo.id,
          userSelectionAction: {
            type: TpEnSelectionFilterTypes.MANUAL,
            description: 'Pasted from clipboard',
            method: formData.actionButtonId,
            selectedItemIds: currentClipBoardData!.selectedItems,
          },
        }),
      );
    });
  }
}
